<template>
    <div class="block-homepage-header__info">
        <div class="pt-1 pb-2 py-lg-2 col-12 col-xl-6">
            <div class="tiny-slider d-xl-flex justify-content-xl-center">
                <SchoolStatistic
                    v-for="statistic in schoolInfo"
                    :key="statistic.id"
                    :statistic="statistic"
                ></SchoolStatistic>
            </div>
        </div>
        <div class="col-xl-6 d-none d-xl-flex">
            <div class="header__btn-group">
                <a
                    v-for="button in navButtons"
                    :key="button.caption"
                    :href="button.url"
                    :target="button.target"
                    class="btn"
                    >{{ button.name }}</a
                >
            </div>
        </div>
    </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import SchoolStatistic from '@/components/homepage/homepage-statistic';
export default {
    components: {
        SchoolStatistic
    },
    props: {
        schoolInfo: {
            type: Array,
            default() {
                return {};
            }
        },
        navButtons: {
            type: Array,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            slider: null
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.initSlider();
        });
    },

    methods: {
        initSlider() {
            this.slider = tns({
                container: this.$el.querySelector('.tiny-slider'),
                items: 2,
                gutter: 10,
                slideBy: 1,
                mouseDrag: false,
                rewind: true,
                swipeAngle: false,
                controls: false,
                lazyload: false,
                nav: false,
                autoplayButton: false,
                autoplayButtonOutput: false,
                autoplay: true,
                preventScrollOnTouch: 'auto',
                speed: 400,
                responsive: {
                    1200: {
                        disable: true
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.block-homepage-header__info {
    position: relative;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-right: -15px;
    margin-left: -15px;
}

.block-homepage-header__info .btn {
    background-color: $color-white;
    color: $color-black;
    padding: 12px 2rem;
    flex: 0 0 calc(50% - 30px);
    align-self: center;
    margin: 0 5px;
    max-width: 280px;

    &:hover {
        color: $color-black;
    }

    &:last-of-type {
        background-color: $color-orange;
        color: $color-white;

        &:hover {
            color: $color-white;
        }
    }
}

.header__btn-group {
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
</style>
